import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getUserSkillList } from '../../api/userSkill';
import { message } from 'antd';

// 获取用户技能列表
export const fetchUserSkills = createAsyncThunk(
  'userSkill/fetchUserSkills',
  async (params, { rejectWithValue }) => {
    try {
      const response = await getUserSkillList(params);
      return response.data;
    } catch (error) {
      message.error('获取用户技能列表失败');
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  userSkillList: {
    data: [],
    total: 0,
    current: 1,
    size: 10,
    loading: false,
    searchParams: {
      userId: undefined,
      username: undefined,
      nickname: undefined,
      skillName: undefined,
      skillLevel: undefined,
      isPublic: undefined,
      startTime: undefined,
      endTime: undefined
    }
  }
};

const userSkillSlice = createSlice({
  name: 'userSkill',
  initialState,
  reducers: {
    setSearchParams: (state, action) => {
      state.userSkillList.searchParams = {
        ...state.userSkillList.searchParams,
        ...action.payload
      };
      
      // 如果传入了页码或每页条数，更新对应的值
      if (action.payload.page) {
        state.userSkillList.current = action.payload.page;
      }
      
      if (action.payload.size) {
        state.userSkillList.size = action.payload.size;
      }
    },
    resetSearchParams: (state) => {
      state.userSkillList.searchParams = {
        userId: undefined,
        username: undefined,
        nickname: undefined,
        skillName: undefined,
        skillLevel: undefined,
        isPublic: undefined,
        startTime: undefined,
        endTime: undefined
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserSkills.pending, (state) => {
        state.userSkillList.loading = true;
      })
      .addCase(fetchUserSkills.fulfilled, (state, action) => {
        state.userSkillList.loading = false;
        state.userSkillList.data = action.payload.records;
        state.userSkillList.total = action.payload.total;
        state.userSkillList.current = action.payload.current;
        state.userSkillList.size = action.payload.size;
      })
      .addCase(fetchUserSkills.rejected, (state) => {
        state.userSkillList.loading = false;
      });
  }
});

export const { setSearchParams, resetSearchParams } = userSkillSlice.actions;
export default userSkillSlice.reducer; 